<app-steps [step]='4'></app-steps>

<div class="row">
  <div class="col-sm-8">
    <div class="card">
      <div class="card-body">
        <h1 class="display-4 main-title">Booking Completed</h1>
        <br>
        <p class="lead">Thank you for your booking. An email confirming your booking details has been sent to your inbox.
        </p>
        <hr class="my-4">
        
        <p class="lead"><b>Below is your appointment details:</b></p>
        <div class="row" *ngIf="appointmentResult==null || treatment==null">
          <div class="col">
            <div class="form-control-plaintext">
              <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading Appointment Details....
            </div>
          </div>
        </div>
        <div *ngIf="appointmentResult!=null && treatment!=null">
          <div class="row">
            <div class="col-12 col-sm-6">
              <mat-form-field appearance="outline">
                <mat-label>Treatment</mat-label>
                <input matInput readonly value="{{treatment.name}}" type="text">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
              <mat-form-field appearance="outline">
                <mat-label>Practitioner</mat-label>
                <input matInput readonly value="{{slot.slots[0].staffName}}" type="text">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="outline">
                <mat-label>Appointment Date</mat-label>
                <input matInput readonly value="{{appointmentResult.startTime | date: 'dd-MM-yyyy'}}" type="text">
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field appearance="outline">
                <mat-label>Appointment Time</mat-label>
                <input matInput readonly value="{{appointmentResult.startTime | date: 'hh:mm a'}}" type="text">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="col-sm-4">
    <ul class="list-group bg-transparent" style="border-radius: 0px;" *ngIf="appointmentResult!=null && treatment!=null">
      <li class="list-group-item">
        <b class="">Add to Calendar</b>
      </li>
      <li class="list-group-item cursur">
        <div color="primary" class="addeventatc" data-styling="none"  data-direct="apple" style="width: 100%">
          <img src="https://www.addevent.com/gfx/icon-apple-t5.svg" style="width: 24px;">&nbsp;Apple
          <span class="start">{{appointmentResult.startTime}}</span>
          <span class="end">{{appointmentResult.endTime}}</span>
          <span class="title">Universal Health</span>
          <span class="description">{{treatment.name}}</span>
          <span class="location">{{app.branch.address}}</span>
          <span class="organizer">{{app.branch.branchName}}</span>
          <span class="organizer_email">{{app.branch.email}}</span>
          <span class="all_day_event">false</span>
          <span class="date_format">MM/DD/YYYY</span>
        </div>
      </li>
      <li class="list-group-item cursur">

        <div color="primary" class="addeventatc" data-styling="none" data-direct="google" style="width: 100%">
          <img src="https://www.addevent.com/gfx/icon-google-t5.svg" style="width: 24px;">&nbsp;Google
          <em>(online)</em>
          <span class="start">{{appointmentResult.startTime}}</span>
          <span class="end">{{appointmentResult.endTime}}</span>
          <span class="title">Universal Health</span>
          <span class="description">{{treatment.name}}</span>
          <span class="location">{{app.branch.address}}</span>
          <span class="organizer">{{app.branch.branchName}}</span>
          <span class="organizer_email">{{app.branch.email}}</span>
          <span class="all_day_event">false</span>
          <span class="date_format">MM/DD/YYYY</span>
        </div>
      </li>
      <li class="list-group-item cursur">
        <div color="primary" class="addeventatc" data-styling="none" data-direct="outlook" style="width: 100%">
          <img src="https://www.addevent.com/gfx/icon-outlook-t5.svg" style="width: 24px;">&nbsp;Outlook
          <span class="start">{{appointmentResult.startTime}}</span>
          <span class="end">{{appointmentResult.endTime}}</span>
          <span class="title">Universal Health</span>
          <span class="description">{{treatment.name}}</span>
          <span class="location">{{app.branch.address}}</span>
          <span class="organizer">{{app.branch.branchName}}</span>
          <span class="organizer_email">{{app.branch.email}}</span>
          <span class="all_day_event">false</span>
          <span class="date_format">MM/DD/YYYY</span>
        </div>
      </li>
      <li class="list-group-item cursur">
        <div color="primary" class="addeventatc" data-styling="none" data-direct="outlookcom" style="width: 100%">
          <img src="https://www.addevent.com/gfx/icon-outlookcom-t5.svg" style="width: 24px;">&nbsp;Outlook.com
          <em>(online)</em>
          <span class="start">{{appointmentResult.startTime}}</span>
          <span class="end">{{appointmentResult.endTime}}</span>
          <span class="title">Universal Health</span>
          <span class="description">{{treatment.name}}</span>
          <span class="location">{{app.branch.address}}</span>
          <span class="organizer">{{app.branch.branchName}}</span>
          <span class="organizer_email">{{app.branch.email}}</span>
          <span class="all_day_event">false</span>
          <span class="date_format">MM/DD/YYYY</span>
        </div>
      </li>
      <li class="list-group-item cursur">
        <div color="primary" class="addeventatc" data-styling="none" data-direct="yahoo" style="width: 100%">
          <img src="https://www.addevent.com/gfx/icon-yahoo-t5.svg" style="width: 24px;">&nbsp;Yahoo
          <em>(online)</em>
          <span class="start">{{appointmentResult.startTime}}</span>
          <span class="end">{{appointmentResult.endTime}}</span>
          <span class="title">Universal Health</span>
          <span class="description">{{treatment.name}}</span>
          <span class="location">{{app.branch.address}}</span>
          <span class="organizer">{{app.branch.branchName}}</span>
          <span class="organizer_email">{{app.branch.email}}</span>
          <span class="all_day_event">false</span>
          <span class="date_format">MM/DD/YYYY</span>
        </div>
      </li>
      <li class="list-group-item bg-primary text-center text-white cursur" (click)="anotherBooking()">
        Make Another Booking
      </li>
    </ul>
  </div>
</div>